<div class="form-sec-col filter-panel" [formGroup]="form">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      Filter
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidePanel()" class="btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="panel-content">

    <h4>Search</h4>
    <mat-form-field class="grow" appearance="outline">
      <input matInput type="text" placeholder="Free text search" formControlName="freetext">
    </mat-form-field>

    <h4>By Time</h4>
    <input class="dateTimePicker startDateTime" [owlDateTime]="filter_dt_start" [owlDateTimeTrigger]="filter_dt_start"
      placeholder="Start date and time" formControlName="startdate">
    <owl-date-time #filter_dt_start [showSecondsTimer]="true"></owl-date-time>

    <input class="dateTimePicker" [owlDateTime]="filter_dt_end" [owlDateTimeTrigger]="filter_dt_end"
      placeholder="End date and time" formControlName="enddate">
    <owl-date-time #filter_dt_end [showSecondsTimer]="true"></owl-date-time>
    <!-- <mat-form-field class="grow">
    <input matInput [matDatepicker]="pickerStart" placeholder="Start date" formControlName="startdate">
    <mat-datepicker-toggle [for]="pickerStart"></mat-datepicker-toggle>
    <mat-datepicker #pickerStart></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="grow">
    <input matInput [matDatepicker]="pickerEnd" placeholder="End date" formControlName="enddate">
    <mat-datepicker-toggle [for]="pickerEnd"></mat-datepicker-toggle>
    <mat-datepicker #pickerEnd></mat-datepicker>
  </mat-form-field> -->

  <h4>By Location</h4>
  <div class="button-row">
    <mat-label>Bounding Box</mat-label>
    @if (bboxDrawMode === 'SET') {
      <div class="bbox-row">
        <div class="bbox-display clearable">
          @for (item of bboxTextArray; track item; let i = $index) {
            <span>
              @if (i===2) {
                <i class="fas fa-arrows-alt"></i>
              }
            </span>
            <span>{{item}}</span>
          }
        </div>
        <button class="clear-button" mat-icon-button color="accent" (click)="clearBoundingBox()" aria-label="Clear">
          X
        </button>
      </div>
    }
    @if (bboxDrawMode === 'EMPTY') {
      <button class="draw-bbox-butt" mat-stroked-button color="accent"
      (click)="startDrawBoundingBox()">Draw</button>
    }
    @if (bboxDrawMode === 'DRAWING') {
      <button class="draw-bbox-butt" mat-stroked-button
      color="secondary">Drawing...</button>
    }
  </div>

  <div class="flex-row">
    <mat-form-field class="flex-grow" appearance="outline">
      <mat-select placeholder="Country name" formControlName="country">
        @for (country of (countriesUsedDictionary?.itemsObs | async); track country) {
          <mat-option [value]="country.id">
            {{country.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (form.get('country')?.value) {
      <button class="flex-grow btn" mat-button mat-icon-button aria-label="Clear"
        (click)="resetCountry()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <h4>By Origin</h4>
  <div class="flex-row">
    <mat-form-field class="flex-grow" appearance="outline">
      <mat-select placeholder="Source e.g myVolcano" formControlName="source">
        @for (source of (sourcesDictionary?.itemsObs | async); track source) {
          <mat-option [value]="source.id">
            {{source.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (source.value!=null) {
      <button class="flex-grow btn" mat-button mat-icon-button aria-label="Clear"
        (click)="resetSource()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>


  <h4>By Attribute</h4>
  <div class="flex-row">
    <!-- <mat-form-field class="flex-grow">
    <mat-select placeholder="Observation Type" formControlName="observationType">
      <mat-option *ngFor="let obsType of (observationTypesDictionary?.itemsObs | async)" [value]="obsType.id">
        {{obsType.name}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
  @if (observationType.value!=null) {
    <button class="flex-grow btn" mat-button mat-icon-button aria-label="Clear"
      (click)="resetObservationType()">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>

<div class="flex-row">
  <!-- <mat-form-field class="flex-grow">
  <mat-select placeholder="Keywords" formControlName="keyword">
    <mat-option *ngFor="let keyWord of (keywordsDictionary?.itemsObs | async)" [value]="keyWord.id">
      {{keyWord.name}}
    </mat-option>
  </mat-select>
</mat-form-field> -->
@if (keyword.value!=null) {
  <button class="flex-grow btn" mat-button mat-icon-button aria-label="Clear"
    (click)="resetKeyword()">
    <mat-icon>close</mat-icon>
  </button>
}
</div>

<div class="space-checkbox">
  <mat-checkbox formControlName="hasPhoto">Has Photograph</mat-checkbox>
</div>


<div class="button-row">
  <button type="button" mat-stroked-button color="primary" [disabled]="resetDisabled"
  (click)="reset()">Reset</button>
  <button type="submit" mat-stroked-button color="accent" [disabled]="submitDisabled"
  (click)="submit()">Submit</button>
</div>
</div>
</div>